import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import {
  Div, H4, SmallButtonForm,
} from 'konsys-ui'
import { theme } from '../../../styles/_variables'
import { LoginRender } from '../../container'

const ReturnPage = ({
  title, children, buttonData, isShowModal,
}) => {
  const [showModal, setShowModal] = useState(false)
  return (
    <Div textAlign='center'>
      <LoginRender class={showModal ? 'modal-active' : 'modal-hide'} hideModal={() => {
        setShowModal(false)
        isShowModal(false)
      }} />
      <H4 style={{ fontWeight: '600' }} margin='0 0 16px' color={theme.color.tertiaryColor}>{title}</H4>
      {
        children
        && <Div bgColor={theme.color.lightPaleGrey} padding='24px' borderRadius='20px'>
        {
          children
        }
        </Div>
      }
      <Div margin='32px 0 0' display='flex' justifyContent='center'>
      {
        buttonData.map((v, index) => {
          if (v.type === 'login') {
            return (
              <SmallButtonForm
                key={index}
                margin='0 8px'
                inverse={v.style === 'inverse'}
                buttonStyle="round"
                color={theme.color.secondaryColor}
                text={v.title}
                onClick={() => {
                  setShowModal(true)
                  isShowModal(true)
                }}
              />
            )
          }
          return (
            <Link to={v.link} key={v.title}>
              <SmallButtonForm margin='0 8px' inverse={v.style === 'inverse'} buttonStyle="round" color={theme.color.secondaryColor} text={v.title} />
            </Link>
          )
        })
      }
      </Div>
    </Div>
  )
}

export default ReturnPage



// WEBPACK FOOTER //
// ./src/components/common/return-page/index.jsx